var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

import styled from "styled-components";
import { colors } from "@wrstudios/theme";
export var Container = styled.button(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: inline-flex;\n  align-items: center;\n  font-size: 1.1rem;\n  font-weight: 600;\n  padding: 0;\n  border: 0;\n  color: ", ";\n  cursor: default;\n  position: relative;\n\n  svg {\n    width: 2.6rem;\n    height: 3.8rem;\n    max-width: none;\n    fill: #5362c6;\n    transform: translate(-50%, 1.2rem);\n    position: absolute;\n    left: 0;\n    bottom: 0;\n  }\n"], ["\n  display: inline-flex;\n  align-items: center;\n  font-size: 1.1rem;\n  font-weight: 600;\n  padding: 0;\n  border: 0;\n  color: ", ";\n  cursor: default;\n  position: relative;\n\n  svg {\n    width: 2.6rem;\n    height: 3.8rem;\n    max-width: none;\n    fill: #5362c6;\n    transform: translate(-50%, 1.2rem);\n    position: absolute;\n    left: 0;\n    bottom: 0;\n  }\n"])), colors.white);
var templateObject_1;